export async function fetchTimeout(
  url: string | URL,
  timeout = 1000,
  options: RequestInit = {},
): Promise<Response> {
  const controller = new AbortController();
  const id = setTimeout(
    () => controller.abort("The request has timed out"),
    timeout,
  );
  const response = await fetch(url, {
    signal: controller.signal,
    ...options,
  });
  clearTimeout(id);

  return response;
}
